import {Component} from 'react'
import {connect} from 'react-redux'
import {Map} from 'immutable'
import PropTypes from 'prop-types'
import {readEndpoint} from 'redux-json-api'

import EverplansConcierge from './everplans_concierge/EverplansConcierge'
import Loader from '../../../../../shared_components/NewLoader'
import PageTitle from '../../../../../shared_components/PageTitle'
import Privacy from './Privacy'
import ProvidedByInformation from './ProvidedByInformation'
import ManageItemPermissionsContainer from './manage_item_permissions/ManageItemPermissionsContainer'
import {currentUserConfig} from '../../../../../lib/userTools'
import {findRawResourceByAttributeId} from '../../../../../lib/plan_data/userData'

import './myProfessionalPartner.scss'

class MyProfessionalPartnerContainer extends Component {
  componentDidMount() {
    const everplanId = this.props.userConfig.get('everplan-id')

    this.props.readEndpoint(
      `everplans/${everplanId}?include=firm-ownership,quarterback-ownership`
    )

    this.props.readEndpoint(`advisor-contact-cards/${everplanId}`)
  }

  render() {
    if (this.props.loading) {
      return <Loader loading={true} />
    } else {
      return (
        <div className='my-professional-partner'>
          <PageTitle title='Everplans Professional Partner - My Account' />
          <h1 className='page-title'>Everplans Professional Partner</h1>
          <ProvidedByInformation
            advisorContactCard={this.props.advisorContactCard}
          />
          <ManageItemPermissionsContainer {...this.props} />
          <EverplansConcierge
            quarterbackOwnership={this.props.quarterbackOwnership}
            readEndpoint={this.props.readEndpoint}
          />
          <Privacy
            advisorContactCard={this.props.advisorContactCard}
          />
        </div>
      )
    }
  }
}

MyProfessionalPartnerContainer.propTypes = {
  advisorContactCard: PropTypes.instanceOf(Map),
  firmOwnership: PropTypes.instanceOf(Map),
  loading: PropTypes.bool,
  quarterbackOwnership: PropTypes.instanceOf(Map),
  readEndpoint: PropTypes.func,
  userConfig: PropTypes.instanceOf(Map)
}

const mapStateToProps = ({api}) => {
  const userConfig = currentUserConfig(api)

  const advisorContactCard = findRawResourceByAttributeId({
    rawResource: api['advisor-contact-cards'],
    attribute: 'everplan-id',
    id: userConfig.get('everplan-id')
  })

  const firmOwnership = findRawResourceByAttributeId({
    rawResource: api['firm-ownerships'],
    attribute: 'everplan-id',
    id: userConfig.get('everplan-id')
  })

  const quarterbackOwnership = findRawResourceByAttributeId({
    rawResource: api['quarterback-ownerships'],
    attribute: 'everplan-id',
    id: userConfig.get('everplan-id')
  })

  return ({
    firmOwnership,
    advisorContactCard,
    loading: (advisorContactCard.isEmpty() || firmOwnership.isEmpty()),
    quarterbackOwnership,
    userConfig
  })
}

export default connect(mapStateToProps, {readEndpoint})(MyProfessionalPartnerContainer)
